<div *ngIf="customer" class="container-fluid">
  <app-header titleText="CUSTOMERS" i18n-titleText>
    <div button>
      <div *ngIf="customer.customer_ID">
        <button *ngIf="canEdit && this.customer.customer_IsActive" class="btn btn-bidit-warn" (click)="deleteCustomer()" i18n>Inactivate Customer</button>
        <button *ngIf="canEdit && !this.customer.customer_IsActive " class="btn btn-bidit-action" (click)="activateCustomer()" i18n>Activate Customer</button>
      </div>
    </div>
  </app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/customer_circle.png" alt="Customer Icon" class="card-icon" />

      <div class="row">
        <div class="container-fluid col-sm-12">
          <h5>{{customer.customer_BusinessName}}</h5>
        </div>
      </div>

      <div class="row header-text mb-1">
        <div class="col-md-4">
          <p>
            <ng-template [ngIf]="customer.mainContact">{{customer.mainContact.contact_LastName}}, {{customer.mainContact.contact_FirstName}}<br></ng-template>
            {{customer.customer_Address1}}<br>
            <span *ngIf="customer.customer_Address2">
              {{customer.customer_Address2}}<br>
            </span>
            {{customer.customer_City}}, {{customer.customer_State}} {{customer.customer_Portal}}<br>
            <ng-template [ngIf]="customer.mainContact">
              <span i18n>Phone:</span> {{customer.mainContact.contact_Phone}}<br>
              <span i18n>Cell:</span> {{customer.mainContact.contact_Mobile}}<br>
              {{customer.mainContact.contact_Email}}
            </ng-template>
          </p>
        </div>
        <div class="col-md-4">
          <p>
            <ng-template [ngIf]="customer.customerType">{{customer.customerType.customerType_Desc}}<br></ng-template>
            <ng-template [ngIf]="customer.office"><span i18n>Office:</span> {{customer.office.office_Name}}<br></ng-template>
            <ng-template [ngIf]="customer.assignedTo"><span i18n>Salesperson:</span> {{customer.assignedTo.lastName}}, {{customer.assignedTo.firstName}}</ng-template>
          </p>
        </div>
        <div class="col-md-4">
          <h7><span i18n>Created By:</span> <ng-template [ngIf]="customer.createdBy">{{customer.createdBy.firstName}} {{customer.createdBy.lastName}}</ng-template><br /></h7>
          <h7><span i18n>Date:</span> {{customer.customer_Created | date: 'M/d/yyyy'}}</h7><br />
          <a href="http://maps.google.com/?q={{customer.customer_Address1}},{{customer.customer_City}}%20{{customer.customer_State}}%20{{customer.customer_Postal}}" target="_blank"
             class="btn btn-bidit-navigate" i18n>Map Customer</a>
        </div>
      </div>

      <mat-tab-group [(selectedIndex)]="customerTabIndex">
        <mat-tab label="Customer Info" i18n-label>
          <app-customer-info-desktop [customerObject]="customer" (updated)="customerUpdated($event)"></app-customer-info-desktop>
        </mat-tab>
        <mat-tab label="Projects" i18n-label>
          <h5 class="d-inline mr-3" i18n>Projects</h5>
          <a *ngIf="canAddQuote" [routerLink]="['/quote/add']" [queryParams]="{customerId:customer.customer_ID}" class="btn btn-bidit-navigate" i18n>Add Quote</a>
          <div class="content">
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Project Name</th>
                  <th i18n>Project Nbr</th>
                  <th i18n>Date Created</th>
                  <th i18n>Bid Amount</th>
                  <th i18n>Project Type</th>
                  <th i18n>Quote Status</th>
                  <th i18n>Salesperson</th>
                  <th>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="customer.quotes.length==0">
                  <td colspan="7"><h5 i18n>No projects for this customer exist</h5></td>
                </tr>
                <tr *ngFor="let quote of customer.quotes">
                  <td>
                    <a *ngIf="quote.quote_Converted==null" routerLink="/quote/{{quote.quote_ID}}">{{quote.quote_Name}}</a>
                    <a *ngIf="quote.quote_Converted" routerLink="/job/{{quote.quote_ID}}">{{quote.quote_Name}}</a>
                  </td>
                  <td>
                    {{quote.quote_ProjectNumber}}
                  </td>
                  <td>{{quote.quote_Created | date : 'MM/dd/yyyy'}}</td>
                  <td>
                    <span *ngIf="quote.quote_BidAmount">
                      ${{quote.quote_BidAmount | number : '1.2'}}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="quote.quote_Converted; else quoteBlock" i18n>Job</span>
                    <ng-template #quoteBlock>
                      <span *ngIf="quote.quote_IsLead" i18n>Lead</span>
                      <span *ngIf="!quote.quote_IsLead" i18n>Quote</span>
                    </ng-template>
                  </td>
                  <td class="text-success">
                    <ng-container *ngIf="quote.quote_Converted; else activeQuote" i18n>Won</ng-container>
                    <ng-template #activeQuote>
                      <span *ngIf="quote.isExpired" class="text-danger" i18n>Expired</span>
                      <span *ngIf="quote.quote_IsLost" class="text-danger" i18n>Lost</span>
                      <span *ngIf="quote.isExpired==false && quote.quote_IsLost == false" i18n>Active</span>
                    </ng-template>
                  </td>
                  <td>
                    <span *ngIf="quote.assignedTo">{{quote.assignedTo.firstName}} {{quote.assignedTo.lastName}}</span>
                  </td>
                  <td>
                    <a *ngIf="quote.quote_Converted==null" routerLink="/quote/{{quote.quote_ID}}" class="btn btn-bidit-edit"></a>
                    <a *ngIf="quote.quote_Converted" routerLink="/job/{{quote.quote_ID}}" class="btn btn-bidit-edit"></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Contacts" i18n-label>
          <div class="content">
            <h5 class="d-inline mr-3" i18n>Contacts</h5>
            <button *ngIf="canEdit" class="btn btn-bidit-navigate" (click)="openContactDialog()" i18n>Add Contact</button>
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Contact Name</th>
                  <th i18n>Contact Type</th>
                  <th i18n>Phone</th>
                  <th i18n>Email</th>
                  <th i18n>Primary</th>
                  <th i18n>Active</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="customer.contacts.length==0">
                  <td colspan="7"><h5 i18n>No contacts for this customer exist</h5></td>
                </tr>
                <tr *ngFor="let contact of customer.contacts">
                  <td>{{contact.contact_LastName}}, {{contact.contact_FirstName}}</td>
                  <td>{{contact.contactType?.contactType_Desc}}</td>
                  <td>{{contact.contact_Phone}}</td>
                  <td>{{contact.contact_Email}}</td>
                  <td>
                    <mat-radio-group name="primary" [(ngModel)]="this.primaryContact" (change)="primaryContactChanged($event)">
                      <mat-radio-button [disabled]="!canEdit" value="{{contact.contact_ID}}"></mat-radio-button>
                    </mat-radio-group>
                  </td>
                  <td>
                    <label [ngClass]="{'text-success' : contact.contact_IsActive}" i18n>active</label>
                    <input (change)="toggleContactStatus(contact, $event)" [disabled]="!canEdit" type="checkbox" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!contact.contact_IsActive" (ngModelChange)="contact.contact_IsActive = $event">
                    <label [ngClass]="{'text-danger' : !contact.contact_IsActive}" i18n>inactive</label>
                  </td>
                  <td>
                    <button *ngIf="canEdit" class="btn btn-bidit-edit" (click)="openContactDialog(contact)"></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
        <mat-tab [label]="noteLabel">
          <div class="content">
            <div class="form-inline">
              <h5 class="mr-3" i18n>Notes</h5>
              <button *ngIf="canEdit" type="button" class="btn btn-bidit-navigate" (click)="editNote()" i18n>Add Note</button>
            </div>
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Note</th>
                  <th i18n>Created By</th>
                  <th i18n>Date</th>
                  <th>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="notes">
                <tr *ngIf="notes.length==0">
                  <td colspan="6"><h5 i18n>No notes for this customer exist</h5></td>
                </tr>
                <tr *ngFor="let note of notes">
                  <td>{{note.note_Text}}</td>
                  <td>
                    <span *ngIf="note.createdBy">
                      {{note.createdBy.firstName}} {{note.createdBy.lastName}}
                    </span>
                  </td>
                  <td>{{note.note_Created | date: 'M/d/yyyy'}}</td>
                  <td>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-edit mr-1" (click)="editNote(note)"></button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-delete" (click)="deleteNote(note)"></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
        <mat-tab [label]="documentLabel">
          <div class="content">
            <div class="form-inline">
              <h5 class="mr-3" i18n>Documents</h5>
              <button *ngIf="canEdit" type="button" class="btn btn-bidit-navigate" (click)="editDocument()" i18n>Add Document</button>
            </div>
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Description</th>
                  <th i18n>File Name</th>
                  <th i18n>Date Uploaded</th>
                  <th>
                  </th>
                </tr>
              </thead>
              <tbody *ngIf="documents">
                <tr *ngIf="documents.length==0">
                  <td colspan="6"><h5 i18n>No documents for this customer exist</h5></td>
                </tr>
                <tr *ngFor="let document of documents">
                  <td>{{document.note_Text}}</td>
                  <td>
                    {{document.note_Attachment}}
                  </td>
                  <td>{{document.note_Created | date: 'M/d/yyyy'}}</td>
                  <td>
                    <button *ngIf="document.note_Attachment" (click)="downloadAttachment(document)" class="btn btn-success mr-1" i18n>Download</button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-edit mr-1" (click)="editDocument(document)"></button>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-delete" (click)="deleteNote(document)"></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
        <mat-tab label="Job History" i18n-label>
          <div class="content">
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Job Name</th>
                  <th i18n>Bid Amount</th>
                  <th i18n>Date Converted</th>
                  <th i18n>Salesperson</th>
                  <th i18n>Work Orders</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="jobs.length==0">
                  <td colspan="6"><h5 i18n>No job history for this customer exists</h5></td>
                </tr>
                <tr *ngFor="let job of jobs">
                  <td>{{job.quote_Name}}</td>
                  <td>${{job.quote_BidAmount | number: '1.2-2'}}</td>
                  <td>{{job.quote_Converted | date: 'MM/dd/yyyy'}}</td>
                  <td>
                    <span *ngIf="job.assignedTo">
                      {{job.assignedTo.firstName}} {{job.assignedTo.lastName}}
                    </span>
                  </td>
                  <td>{{job.workOrders.length}}</td>
                  <td>
                    <a routerLink="/job/{{job.quote_ID}}" class="btn btn-bidit-navigate" i18n>Manage</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
